// extracted by mini-css-extract-plugin
export default {"infoContainer":"style_infoContainer__z-FvW","titleAction":"style_titleAction__LDZMB","personnalData":"style_personnalData__L0AkS","fullname":"style_fullname__NuCqq"};